export default {
      id: "icon-caret-left-usage",
      viewBox: "0 0 7 14",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-caret-left",
      toString: function () {
        return this.url;
      }
    }